import styled, { css } from 'styled-components'
import { Button } from '../Button'
import { getUnstyledButton } from '../Semantic/Semantic.styles'
import { getTypographyIntent } from '../Typography'
import { colors } from '../_styles/colors'
import { getEllipsis, getFocus, getGapOutlineFocus } from '../_styles/mixins'
import { spacing } from '../_styles/spacing'

export const StyledErrorIcon = styled.span`
  align-items: center;
  color: ${colors.white};
  display: inline-flex;
  flex: 0 0 auto;
  margin-right: ${spacing.xs}px;
`

export const StyledErrorButton = styled.button`
  ${getUnstyledButton}
  align-items: center;
  border-radius: 50%;
  color: ${colors.white};
  display: inline-flex;
  flex: 0 0 auto;
  margin-right: ${spacing.xs}px;

  &:focus-visible {
    ${getGapOutlineFocus('ontop')}
  }
`

export const StyledLabel = styled.span`
  ${getTypographyIntent('body')}

  ${getEllipsis}

  flex: 0 1 auto;
`

export const StyledRemove = styled(Button)`
  border-radius: 100%;
  color: ${colors.white};
  flex: 0 0 auto;
  height: 16px;
  margin: 0 -${spacing.sm}px 0 ${spacing.sm}px;
  padding: 0;
  width: 16px;

  &:hover {
    background: ${colors.white};
    color: ${colors.blue40};
  }

  &:disabled,
  &[aria-disabled='true'] {
    color: ${colors.white};
  }
`

export const StyledToken = styled.div<{
  $disabled: boolean
  $focused: boolean
  $error: boolean
}>`
  align-items: center;
  background-color: ${colors.blue50};
  border-radius: 200px; // TODO investigate this magic number
  border: 1px solid transparent;
  color: ${colors.white};
  cursor: default;
  display: inline-flex;
  height: 24px;
  line-height: 1; // TODO investigate this magic number
  max-width: 360px; // TODO investigate this magic number
  min-width: 48px; // TODO investigate this magic number
  padding: ${spacing.xs}px ${spacing.md}px;

  &:hover,
  &.hover {
    background-color: ${colors.blue45};
  }

  ${({ $focused = false, $disabled = false }) =>
    $focused &&
    css`
      ${getFocus()}

      background-color: ${colors.blue45};

      ${!$disabled &&
      css`
        ${StyledRemove} {
          background-color: ${colors.white};
          color: ${colors.blue45};
        }
      `}
    `}

  ${({ $disabled = false }) =>
    $disabled &&
    css`
      background-color: ${colors.gray70};
      border-color: transparent;
      box-shadow: none;
      pointer-events: none;
    `}

  ${({ $error = false }) =>
    $error &&
    css`
      padding-left: ${spacing.xs}px;

      &,
      &:hover {
        background-color: ${colors.red50};
      }
    `}
`
